import { render, staticRenderFns } from "./Candidatar.vue?vue&type=template&id=0f5de065&scoped=true&lang=pug&"
import script from "./Candidatar.vue?vue&type=script&lang=js&"
export * from "./Candidatar.vue?vue&type=script&lang=js&"
import style0 from "./Candidatar.styl?vue&type=style&index=0&id=0f5de065&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5de065",
  null
  
)

export default component.exports